export default __webpack_public_path__ + "static/media/k_series_order_tag.4cac449a.jpg";